<template>
  <div>
    <b-form-group
      class="mt-3 mb-0"
      v-for="subGroup in subGroups"
      :key="subGroup.name"
    >
      <label>
        {{ $t(`permissions.groups.${subGroup.name}`) }}
      </label>
      <permission-items
        :user="user"
        :permissions="subGroup.permissions"
        :is-disabled="isDisabled"
      >
      </permission-items>
    </b-form-group>
  </div>
</template>

<script>
import PermissionItems from '@/domain/components/generalPanel/adminPanel/user/editing/PermissionItems';

export default {
  name: 'permission-sub-groups',
  components: {
    PermissionItems,
  },
  props: {
    user: Object,
    subGroups: Array,
    isDisabled: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
    };
  },
};
</script>
